export enum DefaultCoverageQuotationValueStrategyEnum {
  ESTATE_MULTIPLIER_TIMES_RENT_VALUE = 'ESTATE_MULTIPLIER_TIMES_RENT_VALUE',
  ONE_TENTH_ESTATE_MULTIPLIER_TIMES_RENT_VALUE = 'ONE_TENTH_ESTATE_MULTIPLIER_TIMES_RENT_VALUE'
}
